<template>
    <div v-if="status" style="width: 100%;">
        <div v-if="status !== 'ongoing'" class="card-container">
            <Card :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`" style="margin: 0 auto;"
                  :newLayout="true"
                  :hideFooter="false">
                <template slot="card-header">
                    <h1 v-translate>{{loginHeading}}</h1>
                </template>
                <template slot="card-body">
                    <!--    <div v-if="status === 'upcoming' && time <= currentDate" class="alert-warning-custom">-->
                    <div v-if="status === 'upcoming'" class="alert-warning-custom">
                        <!-- <span style="font-weight: bold; width: 100%; display: inline-block">Upcoming Maintenance {{ upMonth }} {{ upDay }}, {{ upYear }} {{ filtertime }} </span>-->
                        <!--   <span style="font-weight: bold; width: 100%; display: inline-block">Upcoming Maintenance</span>-->
                        <span style="width: 100%; display: inline-block">{{ maintenance.notification_message }}</span>
                    </div>
                    <form
                      ref="form"
                      method="POST"
                      :action="$laraRoute('login')"
                      @submit.prevent="handleForm"
                      :aria-label="'Login' | translate"
                      novalidate>
                        <div class="form-group row justify-content-center align-items-start"
                             v-if="!isSmartCharts">
                            <p class="text-standard" v-translate>You can use the same email password as you do with your SmartCharts account.</p>
                        </div>

                        <div class="form-group row justify-content-center align-items-start">
                            <div class="col-md-3">
                                <label
                                  for="email"
                                  v-translate
                                >E-Mail</label>
                            </div>
                            <div class="col-md-6">
                                <Input
                                  :rule="'required|email'"
                                  name="email"
                                  type="email"
                                  errorType="email"
                                  model="email"
                                  module="Auth"
                                  :required="true"
                                />
                            </div>
                        </div>

                        <div class="form-group row justify-content-center align-items-start">
                            <div class="col-md-3">
                                <label
                                  for="password"
                                  v-translate
                                >Password</label>
                            </div>
                            <div class="col-md-6">
                                <input
                                  v-validate="'required'"
                                  id="password"
                                  :type="pwordHidden ? 'password' : 'text'"
                                  class="form-control"
                                  name="password"
                                  :disabled="formSubmitting ? true : false"
                                  v-model.lazy="password"
                                  required
                                >
                                <InlineError
                                  :errors="errors"
                                  type="password"
                                />

                                <div
                                  tabindex="0"
                                  class="eye-container"
                                  @click="togglePassword"
                                  @keyup.enter.space="togglePassword"
                                  aria-label="Reveals or hides password"
                                >
                                    <object
                                      tabindex="-1"
                                      v-show="pwordHidden"
                                      data="/img/eye.svg"
                                      type="image/svg+xml"
                                      alt="Password hidden"
                                    ></object>
                                    <object
                                      tabindex="-1"
                                      v-show="!pwordHidden"
                                      data="/img/eye-filled.svg"
                                      type="image/svg+xml"
                                      alt="Password revealed"
                                    ></object>
                                </div>
                            </div>
                        </div>

                        <div
                          class="form-group row justify-content-center align-items-start"
                          v-if="sandbox_mode"
                        >
                            <div class="col-md-3">
                                <label
                                  for="callback_url"
                                  class="d-none"
                                  v-translate
                                >Callback URL</label>
                            </div>
                            <div class="col-md-6">
                                <Input
                                  :rule="'required|url'"
                                  name="callback_url"
                                  errorType="callback_url"
                                  model="callbackUrl"
                                  module="Auth"
                                />
                            </div>
                        </div>

                        <div class="form-group row mb-0 mt-4 justify-content-center align-items-start">
                            <div class="col-auto">
                                <Checkbox
                                  :label="rememberMe"
                                  wrapperClass="ml-2"
                                  module="Auth"
                                  modelName="remember_me"
                                />
                            </div>
                        </div>

                        <div class="form-group row mb-0 mt-3 justify-content-center">
                            <div class="col text-center">
                                <router-link
                                  :to="{name: 'forgot-password'}"
                                  class="form__forgot-password"
                                  v-translate
                                >Forgot Password?</router-link>
                            </div>
                        </div>

                        <input
                          type="submit"
                          style="display: none;"
                        >
                    </form>
                </template>
                <template slot='card-footer'>
                    <div class="row justify-content-center">
                        <div class="col-md-8">
                            <flash-message></flash-message>
                        </div>
                    </div>

                    <div class="row align-items-center">
                        <div class="col-sm-6">
                            <CustomSelect
                              :options="$language.available"
                              :label="'language'"
                              :handler="languageHandler"
                              :hasValue="$language.available[language ? language : currentLang]"
                            >
                                <template slot-scope="{slotKey}">
                                    <span :class="`${$codes[slotKey] ? $codes[slotKey].class : null}`"></span>&nbsp;
                                </template>
                            </CustomSelect>
                        </div>

                        <div class="col-sm-auto ml-auto mt-2 mt-sm-0">
                            <LoaderedButton
                              :clickHandler="submitForm"
                              btnClasses="btn btn-primary btn-full"
                              :content="buttonText"
                            />
                        </div>
                    </div>
                </template>
            </Card>
        </div>
        <div v-else class="card-container">
            <div class="card-content">
                <div class="maintenance-card">
                    <i class="fa fa-fw fa-cogs"></i>
                    {{ maintenance.message }}
                </div>
                <div style="padding: 10px 30px 40px;">
                    <span>System will be back in <span style="font-weight: 600">
                        {{ curDays }} days, {{ curHours }} hrs, {{ curMin }} mins, {{ timerCount }} secs</span>
                    </span>
                    <div style="color: rgba(0, 0, 0, 0.74); font-weight: 600;">{{ month }}-{{ day }}-{{year }} @ {{ filtermaintenanceEnddate }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    import { mapFields } from 'vuex-map-fields';
    import Card from '@C/Card';
    import LoaderedButton from '@C/LoaderedButton';
    import Checkbox from '@C/Checkbox';
    import FlashMessage from '@C/FlashMessage';
    import CustomSelect from '@C/CustomSelect';
    import Input from '@C/Forms/Input';
    import InlineError from '@C/Forms/InlineError';
    import validator from '@M/validationWrapper';
    import route from '@H/route';

    export default {
        name: 'Login',
        data() {
            return {
                status: 'off',
                time: '',
                loading: false,
                now: new Date(),
                currentDate: '',
                maintenance: {},
                url: window.ENV.SC_ADMIN_URL,
                // url: config('app.go_to_smartcharts'),
                maintenanceEndtime: '',
                maintenanceNewEndtime: '',
                maintenanceTimeInterval: '',
                timerCount: '',
                curHours: 0,
                curMin: 0,
                curSec: 0,
                curDays: 0,
                filtermaintenanceEnddate: '',
                day: '',
                month: '',
                year: '',
                upDay: '',
                upMonth: '',
                upYear: '',
                filtertime: '',
                milisec: ''
            }
        },
        watch: {
            timerCount: {
                handler(value) {
                    // console.log(value)
                    if(this.status === 'ongoing') {
                        if (value > 0) {
                            setTimeout(() => {
                                this.timerCount--;
                            }, 1000);
                        } else if (value === '') {
                            setTimeout(() => this.convertEndTime(), 1000)
                        } else {
                            if (this.curDays + this.curHours + this.curMin === 0 || this.curDays + this.curHours + this.curMin < 0) {
                                window.location.reload()
                            } else {
                                setTimeout(() => this.convertEndTime(), 1000)
                                this.timerCount = 60
                            }
                        }
                    }
                },
                immediate: true // This ensures the watcher is triggered upon creation
            }
        },
        created: function() {
          if(this.url !== '') {
            this.loading = true
            this.read()
            this.convertTime()
            this.getTime()
          }

          // For redirect set password.
          let tokenUrl = this.$route.query.t;
          if (typeof tokenUrl != 'undefined' && tokenUrl !== '') {   
            this.loading =true;

            axios.post('login', {'set_password_token': tokenUrl}).then(function(res) {
                window.localStorage.setItem('sfData', JSON.stringify(res.data.user));

                axios.post(route('password.generate-token'), {'user': res.data.user}).then(function(res2) {
            
                    window.location = '/password/set/' + res2.data.token + '?email=' + res2.data.email;
                });
            });
          }
        },
        methods: {
            ...mapActions({
                formHandler: 'Auth/login',
                setLanguage: 'setLanguage',
                logout: 'Auth/logout'
            }),
            ...mapMutations({
                togglePassword: 'Auth/togglePassword'
            }),
            languageHandler: function (e) {
                let target = e.target || e;
                let optionEl = target[target.selectedIndex];
                let val = target.value;
                this.setLanguage(optionEl.getAttribute('data-key'));
            },
            submitForm() {
                this.$refs.form.dispatchEvent(new Event('submit', { cancelable: true }));
            },
            async read() {
                var url = this.url + '/api/maintenance/check'
                Promise.all([
                    await fetch(url).then(res => res.ok && res.json() || Promise.reject(res)),
                ]).then(data => {
                    this.maintenance = data[0].data
                    this.status = data[0].status
                    var time = this.maintenance.schedule_end
                    this.gtime = this.maintenance.schedule_end
                    var notificationtime = this.maintenance.schedule_start
                  if(data) {
                    this.convertEndTime(time)
                    this.convertTime(notificationtime)
                  }
                }).catch(error => {
                  console.error(error.message)
                })
            },
            convertEndTime(value) {
                var mytime =  this.gtime
                var now = new Date()
                var thisdate = new Date(now);
                var date = new Date(mytime);
                // console.log('date',thisdate)
                var dateoptions = {
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: true
                };

                var options = {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: true
                };

                var intoptions = {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: true
                };

                var month = new Array();
                month[0] = "January";
                month[1] = "February";
                month[2] = "March";
                month[3] = "April";
                month[4] = "May";
                month[5] = "June";
                month[6] = "July";
                month[7] = "August";
                month[8] = "September";
                month[9] = "October";
                month[10] = "November";
                month[11] = "December";
                var m = new Date(date)
                var curMonth = month[m.getMonth()];

                var d = new Date(date).getDate()
                var y = new Date(date).getFullYear()

                this.month = curMonth
                this.day = d
                this.year = y

                var filterdate = date.toLocaleString('en-US', dateoptions);
                this.filtermaintenanceEnddate = filterdate.replace(',', '');

                var time = date.toLocaleString('en-US', options);
                this.maintenanceNewEndtime = time.replace(',', '');

                var timeinterval = thisdate.toLocaleString('en-US', intoptions);
                this.maintenanceTimeInterval = timeinterval.replace(',', '');
                // console.log(this.maintenanceTimeInterval)

                setTimeout(() => this.getNewInt(), 1)

                this.loading = false
            },
            getNewInt(){
                var x = this.maintenanceNewEndtime
                var y = this.maintenanceTimeInterval

                var thisdatex = new Date(x);
                var thisdatey = new Date(y);
                // var timeint = x - y
                var diff = Math.abs(thisdatex - thisdatey);  // difference in milliseconds

                this.milisec = diff
                var days = Math.floor(diff / (1000 * 60 * 60 * 24));
                var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((diff % (1000 * 60)) / 1000);

                // console.log(hours, minutes, seconds)
                this.curDays = days
                this.curHours = hours
                this.curMin = minutes
                this.curSec = seconds
                if(this.timerCount === '') {
                    this.timerCount = seconds
                }
            },
            convertTime(value) {
                // console.log(this.maintenance)
                var mytime = value
                var date = new Date(mytime);

                var filteroptions = {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true
                };

                var options = {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true
                };

                var month = new Array();
                month[0] = "January";
                month[1] = "February";
                month[2] = "March";
                month[3] = "April";
                month[4] = "May";
                month[5] = "June";
                month[6] = "July";
                month[7] = "August";
                month[8] = "September";
                month[9] = "October";
                month[10] = "November";
                month[11] = "December";
                var m = new Date(date)
                var curMonth = month[m.getMonth()];

                var d = new Date(date).getDate()
                var y = new Date(date).getFullYear()

                this.upDay = d
                this.upMonth = curMonth
                this.upYear = y

                var time = date.toLocaleString('en-US', options);
                this.time = time.replace(',', '');

                var filtertime = date.toLocaleString('en-US', filteroptions);
                this.filtertime = filtertime.replace(',', '');
            },
            getTime() {
                var date = new Date(this.now);
                var options = {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true
                };

                var currentDate = date.toLocaleString('en-US', options);
                this.currentDate = currentDate.replace(',', '');
            }
        },
        computed: {
            ...mapFields(`Auth`, [
                'password',
                'pwordHidden',
                'remember_me',
                'language'
            ]),
            ...mapState(['currentLang']),
            sandbox_mode: function () {
                return window.sandbox_mode;
            },
            rememberMe: function () {
                return this.$gettext('Remember Me');
            },
            buttonText: function () {
                return this.$gettext('Login');
            },
            isSmartCharts: function () {
                return window.isSmartCharts;
            },
            loginHeading: function () {
                return this.$gettextInterpolate('%{ appName } Log In', {
                    appName: window.appName,
                });
            },
        },
        components: {
            Card,
            LoaderedButton,
            Checkbox,
            CustomSelect,
            Input,
            InlineError,
            FlashMessage
        },
        mixins: [validator]
    };
</script>
<style scoped>
    .alert-warning-custom {
        width: 95%;
        margin: 0 auto 20px;
        color: #f56c6c;
        padding: 8px 16px;
        /* margin: 0; */
        box-sizing: border-box;
        border-radius: 4px;
        position: relative;
        background-color: #fef0f0;
        overflow: hidden;
        opacity: 1;
        display: block;
        align-items: center;
        transition: opacity .2s;
    }

    .timer {
        font-size: 20px;
        color: #fff;
        text-align: center;
        margin-top: 50px;
    }
    .day, .hour, .min, .sec {
        font-size: 30px;
        display: inline-block;
        font-weight: 500;
        text-align: center;
        margin: 0 5px;
    }
    .format {
        font-weight: 300;
        font-size: 14px;
        /*//@include margin-start(5);*/
        /*//display: inline-block;*/
        opacity: 0.8;
        width: 60px;
    }
    .number {
        background: rgba(51, 51, 51, 0.53);
        padding: 0 5px;
        border-radius: 5px;
        display: inline-block;
        width: 60px;
        text-align: center;
    }
    .message {
        font-size: 14px;
        font-weight: 400;
        margin-top: 5px;
    }
    .status-tag {
        width: 270px;
        margin: 10px auto;
        padding: 8px 0;
        font-weight: 500;
        color: #000;
        text-align: center;
        border-radius: 15px;
    }
    .card-container {
        width: 100%;
        display: block;
        text-align: center;
    }
    .card-content {
        /* background-color: red; */
        width: 50%;
        margin: 5% auto;
        /*padding: 20px;*/
        background-color: #fef0f0;
        color: #f56c6c;
        border-radius: 4px;

    }

    .maintenance-card {
        font-weight: bold;
        background-color: #e6a23c;
        padding: 20px;
        margin-bottom: 20px;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/stages/Login.vue